import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import classes from './Rejected.module.css';
import RejectEdit from "./ReJectetEdit";
import RejectedView from "./RejectedView";

const Rejected = ({
    submissionData,
    setSubmissionData,
    markAssessmentAsChecked,
    nextAssessment,
    dynamicIndicatorObj,
    editData,
    setEditData,
    handleNotification }) => {

    const { texts, direction, } = useSelector(state => state.translate);
    const [feedback, setFeedback] = useState()

    useEffect(() => {
        if (submissionData) {
            setFeedback(prevState => ({
                ...prevState,
                remarks: submissionData?.remarks ? submissionData.remarks : null
            }))
        }
    }, [submissionData])

    const setRemarks = (remark) => {
        setFeedback(prevState => ({
            ...prevState,
            remarks: remark
        }))
    }

    return (
        <>
            <div className={`${classes[direction]} ${classes.Rejected}`}>
                <div className={classes.ContainerOverflow}>
                    {feedback && dynamicIndicatorObj &&
                        <div className={classes.Container}>
                            {editData ?
                                <RejectEdit
                                    setRemarks={setRemarks}
                                    feedback={feedback}
                                    setSubmissionData={setSubmissionData}
                                    markAssessmentAsChecked={markAssessmentAsChecked}
                                    handleNotification={handleNotification}
                                    setEditData={setEditData}
                                    submissionData={submissionData}
                                >
                                </RejectEdit>
                                :
                                <RejectedView
                                    submissionData={submissionData}
                                    remarks={feedback.remarks}
                                    dynamicIndicatorObj={dynamicIndicatorObj}
                                    setEditData={setEditData}
                                    nextAssessment={nextAssessment}
                                    title1={submissionData.submittedByUser.isGroup ? texts.assessmentReturnToTeamStudent : texts.assessmentReturnToStudent}
                                    title2={texts.assessmentReturn}
                                    scoreAdditionalData={JSON.parse(submissionData.scoreAdditionalData)}>
                                </RejectedView>
                            }
                        </div>}
                </div>
            </div>
        </>
    )
}
export default Rejected